/* ------------------------------------------ gfOutline 20/05/2017 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import { checkKeyValid } from '@/app/utils/checkRoleApply';

(function (jQuery) {
  jQuery.gfOutline = function (element, options) {
    const defaults = {
      margin: true,
      padding: true,
    };
    this.settings = {};

    const _this = this;

    const _outlineTool =
      '<div class="gf-outline gf-outline--top gf-outline--hidden transition"> <span class="outline-val"></span></div><div class="gf-outline gf-outline--bottom gf-outline--hidden transition"> <span class="outline-val"></span></div><div class="gf-outline gf-outline--left gf-outline--hidden transition"> <span class="outline-val"></span></div><div class="gf-outline gf-outline--right gf-outline--hidden transition"> <span class="outline-val"></span></div>';
    const _marginTool =
      '<div class="gf-margin gf-margin--top gf-margin--hidden transition"><div class="gf-margin-line"></div></div><div class="gf-margin gf-margin--bottom gf-margin--hidden transition"><div class="gf-margin-line"></div></div><div class="gf-margin gf-margin--left gf-margin--hidden transition"><div class="gf-margin-line"></div></div><div class="gf-margin gf-margin--right gf-margin--hidden transition"><div class="gf-margin-line"></div></div>';
    const _errorOutlineTool =
      '<div class="gf-error-outline gf-outline--top gf-outline--hidden transition"> </div><div class="gf-error-outline gf-outline--bottom gf-outline--hidden transition"> </div><div class="gf-error-outline gf-outline--left gf-outline--hidden transition"> </div><div class="gf-error-outline gf-outline--right gf-outline--hidden transition"> </div>';
    var $element = jQuery(element),
      element = element;

    /* Editor */
    const $divTopBar = jQuery('#divTopBar');
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      _this.initOutline();
      _this.applyOutline();

      $element.off('screen-mode-change').on('screen-mode-change', function () {
        setTimeout(function () {
          _this.initOutline(true);
        }, 300);
        return false;
      });

      return false;
    };

    this.initOutline = function (isRefreshOuline) {
      const merName = $element.attr('data-label');

      let addOutline = true;
      switch (merName) {
        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) File Upload':
        case '(P) Description':
        case '(P) Price':
        case '(P) Cart Button':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          addOutline = false;
          break;

        default:
          break;
      }

      if (addOutline) {
        if ($element.children('.gf-outline').length == 0 && !$element.hasClass('gf_row_no_tools')) {
          $element.append(_outlineTool);
        }
      }
      // if ($element.children('.gf-error-outline').length == 0) {
      //   // $element.append(_errorOutlineTool);
      // }
      if ($element.children('.gf-margin').length == 0) {
        $element.append(_marginTool);
      }
      // Support care 'change screen mode' needs to remove `gf-outline--updated` for `gf-outline` to be recalculated
      if (isRefreshOuline) {
        $element.find('.gf-outline--updated').removeClass('gf-outline--updated');
      }

      // hover event
      $element
        .children('.gf-outline')
        .off('mouseover.ol')
        .on('mouseover.ol', function (e) {
          e.preventDefault();
          if (!$gryffEditor.data('gryffeditor').isDragging() && !window._isScrolling) {
            jQuery(this).addClass('hover');
          }
          const $outline = jQuery(this);
          if (!$outline.hasClass('gf-outline--updated')) {
            if ($outline.hasClass('gf-outline--top')) {
              _this.updatePadding('top', '', true, $outline);
            } else if ($outline.hasClass('gf-outline--bottom')) {
              _this.updatePadding('bottom', '', true, $outline);
            } else if ($outline.hasClass('gf-outline--left')) {
              _this.updatePadding('left', '', true, $outline);
            } else if ($outline.hasClass('gf-outline--right')) {
              _this.updatePadding('right', '', true, $outline);
            }
          }
        });
      $element
        .children('.gf-outline')
        .off('mouseleave.ol')
        .on('mouseleave.ol', function (e) {
          e.preventDefault();

          jQuery(this).removeClass('hover');
          if (!$gryffEditor.data('gryffeditor').isDragging() && !window._isScrolling) {
            $element.children('.gf-outline').removeClass('active');
            jQuery(this).addClass('transition');
          }
        });
    };

    this.showOutline = function () {
      if (!$gryffEditor.data('gftexteditor').isEditing()) {
        $element.children('.gf-outline').addClass('gf-outline-show');
      } else {
        if ($gryffEditor.data('gftexteditor')) {
          const $activeElement = $gryffEditor.data('gftexteditor').getActiveElement();
          if ($activeElement.attr('id') != $element.attr('id')) {
            $element.children('.gf-outline').addClass('gf-outline-show');
          }
        }
      }

      return false;
    };

    this.showErrorOutline = function () {
      if ($element.children('.gf-error-outline').length == 0) {
        $element.append(_errorOutlineTool);
      }
      if (!$gryffEditor.data('gftexteditor').isEditing()) {
        $element.children('.gf-error-outline').addClass('gf-outline-show');
      } else {
        if ($gryffEditor.data('gftexteditor')) {
          const $activeElement = $gryffEditor.data('gftexteditor').getActiveElement();
          if ($activeElement.attr('id') != $element.attr('id')) {
            $element.children('.gf-error-outline').addClass('gf-outline-show');
          }
        }
      }

      return false;
    };

    this.hideOutine = function () {
      $element.children('.gf-outline').removeClass('gf-outline-show');
      return false;
    };

    this.showPadding = function (direction, noDelay) {
      $element.children('.gf-outline--' + direction).addClass('hover');
      if (noDelay) {
        $element.children('.gf-outline--' + direction).addClass('no-delay');
      }
      return false;
    };

    this.showMargin = function (direction, noDelay) {
      $element.children('.gf-margin--' + direction).addClass('hover');
      if (noDelay) {
        $element.children('.gf-margin--' + direction).addClass('no-delay');
      }
      return false;
    };

    this.updatePadding = function (direction, value, noDelay, $outline) {
      // Get `$outline` so don't have to find it again `.gf-outline--...`
      if (!$outline) {
        $outline = $element.children('.gf-outline--' + direction);
      }
      $outline.removeClass('transition');

      switch (direction) {
        case 'top':
          if (value) {
            var paddingTop = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var paddingTop = parseInt($element.css('paddingTop'));
            if (paddingTop <= 0) {
              paddingTop = 5;
            }
          }
          $outline.css('height', paddingTop);
          _this.updatePaddingSize(paddingTop, $outline);
          break;

        case 'bottom':
          if (value) {
            var paddingBottom = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var paddingBottom = parseInt($element.css('paddingBottom'));
            if (paddingBottom <= 0) {
              paddingBottom = 5;
            }
          }
          $outline.css('height', paddingBottom);
          _this.updatePaddingSize(paddingBottom, $outline);
          break;

        case 'left':
          if (value) {
            var paddingLeft = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var paddingLeft = parseInt($element.css('paddingLeft'));
            if (paddingLeft <= 0) {
              paddingLeft = 5;
            }
          }
          $outline.css('width', paddingLeft);
          _this.updatePaddingSize(paddingLeft, $outline);
          break;

        case 'right':
          if (value) {
            var paddingRight = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var paddingRight = parseInt($element.css('paddingRight'));
            if (paddingRight <= 0) {
              paddingRight = 5;
            }
          }
          $outline.css('width', paddingRight);
          _this.updatePaddingSize(paddingRight, $outline);
          break;
      }
      $outline.addClass('gf-outline--updated');
      return false;
    };

    this.updateMargin = function (direction, value, noDelay) {
      const $margin = $element.children('.gf-margin--' + direction);
      $margin.removeClass('transition');

      switch (direction) {
        case 'top':
          if (value) {
            var marginTop = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var marginTop = parseInt($element.css('marginTop'));
            if (marginTop <= 0) {
              marginTop = 0;
            }
          }
          $margin.css('height', marginTop);

          break;

        case 'bottom':
          if (value) {
            var marginBottom = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var marginBottom = parseInt($element.css('marginBottom'));
            if (marginBottom <= 0) {
              marginBottom = 0;
            }
          }
          $margin.css('height', marginBottom);
          break;

        case 'left':
          if (value) {
            var marginLeft = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var marginLeft = parseInt($element.css('marginLeft'));
            if (marginLeft <= 0) {
              marginLeft = 5;
            }
          }
          $margin.css('width', marginLeft);
          break;

        case 'right':
          if (value) {
            var marginRight = parseInt(value) <= 0 ? 5 : parseInt(value);
          } else {
            var marginRight = parseInt($element.css('marginRight'));
            if (marginRight <= 0) {
              marginRight = 0;
            }
          }
          $margin.css('width', marginRight);
          break;
      }

      return false;
    };

    this.hidePadding = function (direction, noDelay) {
      $element.children('.gf-outline').removeClass('hover');
      if (noDelay) {
        $element.children('.gf-outline--' + direction).removeClass('no-delay');
      }
      return false;
    };

    this.hideMargin = function (direction, noDelay) {
      $element.children('.gf-margin').removeClass('hover');
      if (noDelay) {
        $element.children('.gf-margin--' + direction).removeClass('no-delay');
      }
      return false;
    };

    this.applyOutline = function () {
      $element
        .children('.gf-outline')
        .off('mousedown.outline')
        .on('mousedown.outline', function (e) {
          // An stopProgagation de co the an duoc context menu
          e.preventDefault();

          const isTabActive = $gfLeftSideBar.find('#md-settings').hasClass('active');
          const edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
          if (!isTabActive || edittingID != $element.attr('id')) {
            if ($element.data('gfmodule') != undefined) {
              $element.data('gfmodule').openModuleSettings();
            } else if ($element.data('gfrow') != undefined) {
              $element.data('gfrow').openRowSettings();
            } else if ($element.parent().data('gfrow') != undefined) {
              $element = $element.parent();
              $element.data('gfrow').openRowSettings();
            } else if ($element.data('gfelement') != undefined) {
              $element.data('gfelement').openElementSettings();
            }
          }

          // no right click
          if (e.which != 3) {
            $gryffEditor.data('gryffeditor').setDragging(true);

            const $target = jQuery(this);
            const $container = $target.parent();

            // fix Youtube Video Module
            $container.find('.gf_youtube-overlay').addClass('show');
            $container.find('.gf_vimeo-overlay').addClass('show');

            const startX = e.pageX;
            const startY = e.pageY;

            let endY;
            let endX;

            let padding = 0;
            let paddingValue = 0;
            let attr = '';

            let style = '';
            let screenType;

            if ($container.hasClass('element-wrap') && $container.find('.elm').hasClass('text-edit')) {
              const { paddingVal, attrVal } = _this.getTargetPadding($target, $container.find('.elm'));
              padding = paddingVal;
              attr = attrVal;
            } else if ($container.hasClass('element-wrap')) {
              const { paddingVal, attrVal } = _this.getTargetPadding(
                $target,
                $container.find('.elm').children().first(),
              );
              padding = paddingVal;
              attr = attrVal;
            } else {
              const { paddingVal, attrVal } = _this.getTargetPadding($target, $container);
              padding = paddingVal;
              attr = attrVal;
            }

            $container.children('.gf-outline').removeClass('transition hover');
            $target.addClass('active');

            // UPDATE CSS
            screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            if ($element.hasClass('gf_row')) {
              if ($element.data('gfrow') != undefined) {
                style = $element.data('gfrow').getRowCSS();
              }
            } else if ($element.hasClass('module-wrap')) {
              if ($element.data('gfmodule') != undefined) {
                style = $element.data('gfmodule').getModuleCSS();
              }
            } else {
              if ($element.data('gfelement') != undefined) {
                style = $element.data('gfelement').getElementCSS();
              }
            }

            const $paddingTop = $gfLeftSideBar.find('#md-settings [name="padding-top"]');
            const $paddingBottom = $gfLeftSideBar.find('#md-settings [name="padding-bottom"]');
            const $paddingLeft = $gfLeftSideBar.find('#md-settings [name="padding-left"]');
            const $paddingRight = $gfLeftSideBar.find('#md-settings [name="padding-right"]');

            $gryffBody.on('mousemove.outline', function (e) {
              e.preventDefault();
              if ($gryffEditor.data('gryffeditor').isDragging()) {
                paddingValue = padding;
                let diff = 0;

                switch (attr) {
                  case 'padding-top':
                    endY = e.pageY;
                    diff = endY - startY;

                    paddingValue += diff;

                    if (paddingValue < 0) {
                      paddingValue = 0;

                      $gryffEditor.data('gryffeditor').setDragging(false);

                      $target.css('height', '5px');
                    } else {
                      $target.css('height', paddingValue);
                    }
                    $paddingTop
                      .attr('value', paddingValue + 'px')
                      .val(paddingValue + 'px')
                      .trigger('value-change');
                    var $outline = $element.children('.gf-outline--top');
                    _this.updatePaddingSize(paddingValue, $outline);
                    break;

                  case 'padding-bottom':
                    endY = e.pageY;
                    diff = endY - startY;

                    paddingValue += diff;
                    if (paddingValue < 0) {
                      paddingValue = 0;

                      $gryffEditor.data('gryffeditor').setDragging(false);

                      $target.css('height', '5px');
                    } else {
                      $target.css('height', paddingValue);
                    }
                    $paddingBottom
                      .attr('value', paddingValue + 'px')
                      .val(paddingValue + 'px')
                      .trigger('value-change');
                    var $outline = $element.children('.gf-outline--bottom');
                    _this.updatePaddingSize(paddingValue, $outline);
                    break;

                  case 'padding-left':
                    endX = e.pageX;
                    diff = endX - startX;

                    paddingValue += diff;
                    if (paddingValue < 0) {
                      paddingValue = 0;

                      $gryffEditor.data('gryffeditor').isDragging(false);

                      $target.css('width', '5px');
                    } else {
                      $target.css('width', paddingValue);
                    }
                    $paddingLeft
                      .attr('value', paddingValue + 'px')
                      .val(paddingValue + 'px')
                      .trigger('value-change');
                    var $outline = $element.children('.gf-outline--left');
                    _this.updatePaddingSize(paddingValue, $outline);
                    break;

                  case 'padding-right':
                    endX = e.pageX;
                    diff = endX - startX;
                    diff *= -1;

                    paddingValue += diff;
                    if (paddingValue < 0) {
                      paddingValue = 0;

                      $gryffEditor.data('gryffeditor').isDragging(false);

                      $target.css('width', '5px');
                    } else {
                      $target.css('width', paddingValue);
                    }
                    $paddingRight
                      .attr('value', paddingValue + 'px')
                      .val(paddingValue + 'px')
                      .trigger('value-change');
                    var $outline = $element.children('.gf-outline--right');
                    _this.updatePaddingSize(paddingValue, $outline);
                    break;
                }

                const deOptions = [
                  {
                    key: attr,
                    value: paddingValue + 'px',
                  },
                ];

                style = HELPER.designOptions2Style($container, screenType, style, deOptions);

                if ($container.hasClass('gf_row')) {
                  if ($container.data('gfrow') != undefined) {
                    $container.data('gfrow').runStyle(style);
                  }
                } else if ($container.hasClass('module-wrap')) {
                  if ($container.data('gfmodule') != undefined) {
                    $container.data('gfmodule').runStyle(style);
                  }
                } else if ($container.hasClass('element-wrap')) {
                  if ($container.data('gfelement') != undefined) {
                    $container.data('gfelement').runStyle(style);
                  }
                }
              }
            });

            $gryffBody.on('mouseup.outline', function (e) {
              e.preventDefault();

              // fix Youtube Video Module
              $container.find('.gf_youtube-overlay').removeClass('show');
              $container.find('.gf_vimeo-overlay').removeClass('show');
              // remove class
              $container.children('.gf-outline').removeClass('active hover');
              $target.addClass('transition');

              window._showToolList = [];
              window._hideToolList = [];

              $gryffEditor.data('gryffeditor').setDragging(false);

              if (e.which != 3 && (endX != undefined || endY != undefined)) {
                if ($container.hasClass('gf_row')) {
                  if ($container.data('gfrow') != undefined) {
                    var isTabActive = $gfLeftSideBar.find('#md-settings').hasClass('active');
                    var tab = jQuery.trim(
                      $gfLeftSideBar.find('#md-settings').find('.simple-tabs ul.simple-tabs-item li.active').text(),
                    );
                    var edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
                    if (!isTabActive || tab != 'Design' || edittingID != $container.attr('id')) {
                      $container.data('gfrow').openRowSettings('Design:Spacing');
                    }
                  }
                } else if ($container.hasClass('module-wrap')) {
                  if ($container.data('gfmodule') != undefined) {
                    var isTabActive = $gfLeftSideBar.find('#md-settings').hasClass('active');
                    var tab = jQuery.trim(
                      $gfLeftSideBar.find('#md-settings').find('.simple-tabs ul.simple-tabs-item li.active').text(),
                    );
                    var edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
                    if (!isTabActive || tab != 'Design' || edittingID != $container.attr('id')) {
                      $container.data('gfmodule').openModuleSettings('Design:Spacing');
                    }

                    // refresh Carousel
                    if ($container.attr('data-label') == 'Carousel') {
                      $container.data('gfmodule').refresh();
                    }
                  }
                } else if ($container.hasClass('element-wrap')) {
                  if ($container.data('gfelement') != undefined) {
                    var isTabActive = $gfLeftSideBar.find('#md-settings').hasClass('active');
                    var tab = jQuery.trim(
                      $gfLeftSideBar.find('#md-settings').find('.simple-tabs ul.simple-tabs-item li.active').text(),
                    );
                    var edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
                    if (!isTabActive || tab != 'Design' || edittingID != $container.attr('id')) {
                      $container.data('gfelement').openElementSettings('Design:Spacing');
                    }
                  }
                }
              }
              $gryffBody.off('mousemove.outline');
              $gryffBody.off('mouseup.outline');

              // Product List detect child change 4
              // Article List detect child change 4
              // History
              setTimeout(function () {
                $gryffEditor.data('gfhistory').addHistory('design-option', $container.attr('id'));
              }, 50);
              setTimeout(function () {
                $gryffEditor.data('gfhistory').captureMERSettings();
              }, 51);

              HELPER.flagListItemChange($container, 'design-options');
              if (HELPER.isInsideTheList($container)) {
                const $itemContent = $container.closest('.item-content');
                HELPER.detectContentChange($itemContent);
              }
            });
          }
        });
    };

    this.getTargetPadding = function (target, container) {
      let padding;
      let attr;
      if (target.hasClass('gf-outline--top')) {
        padding = parseInt(container.css('paddingTop'));
        attr = 'padding-top';
      } else if (target.hasClass('gf-outline--bottom')) {
        padding = parseInt(container.css('paddingBottom'));
        attr = 'padding-bottom';
      } else if (target.hasClass('gf-outline--left')) {
        padding = parseInt(container.css('paddingLeft'));
        attr = 'padding-left';
      } else if (target.hasClass('gf-outline--right')) {
        padding = parseInt(container.css('paddingRight'));
        attr = 'padding-right';
      }
      return { paddingVal: padding, attrVal: attr };
    };

    this.addPaddingStyle = function (attr, paddingValue, $container) {
      const paddingStyle = attr + ':' + paddingValue + 'px!important;';
      let styleCSS = $container.attr('style');
      if (!styleCSS) {
        styleCSS = '';
      }
      const regex = new RegExp(attr + '(.*?;)', 'g');
      if (styleCSS.match(regex)) {
        styleCSS = styleCSS.replace(regex, paddingStyle);
      } else {
        styleCSS += paddingStyle;
      }
      // set style
      $container.attr('style', styleCSS);
      return false;
    };

    this.removePaddingStyle = function (attr, $container) {
      let styleCSS = $container.attr('style');
      if (styleCSS) {
        const regex = new RegExp(attr + '(.*?;)', 'g');
        if (styleCSS.match(regex)) {
          styleCSS = styleCSS.replace(regex, '');
          $container.attr('style', styleCSS);
        }
      }
      return false;
    };

    this.updatePaddingSize = function (paddingValue, $container) {
      if (paddingValue <= 30) {
        // Nếu nhỏ hơn 40 thì không hiển thị
        $container.find('.outline-val').text('');
        return false;
      }

      $container.find('.outline-val').text(paddingValue + 'px');

      if ($container.hasClass('gf-outline--top') || $container.hasClass('gf-outline--bottom')) {
        let paddingBottomValue = $element.children('.gf-outline--bottom').find('.outline-val').text();
        paddingBottomValue = parseInt(paddingBottomValue);
        let paddingTopValue = $element.children('.gf-outline--top').find('.outline-val').text();
        paddingTopValue = parseInt(paddingTopValue);
        $element
          .children('.gf-outline--left')
          .find('.outline-val')
          .css({
            top: 'calc(50% + ' + (parseInt(paddingTopValue) / 2 - paddingBottomValue / 2) + 'px)',
          });
        $element
          .children('.gf-outline--right')
          .find('.outline-val')
          .css({
            top: 'calc(50% + ' + (parseInt(paddingTopValue) / 2 - paddingBottomValue / 2) + 'px)',
          });
      }
    };

    this.init();
  };

  jQuery.fn.gfOutline = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfoutline')) {
        const plugin = new jQuery.gfOutline(this, options);
        jQuery(this).data('gfoutline', plugin);
      }
    });
  };
})(jQuery);
